/**
 * Client-side fetch helpers for notification history API
 */
import { tokenService } from "./tokenService";
const API_URL = process.env.NEXT_PUBLIC_API_URL || "";

export type Notification = {
  id: number;
  heading: string;
  message: string;
  url: string | null;
  type: "filter" | "price_drop";
  is_read: boolean;
  created_at: string;
};

const getAuthHeaders = async (): Promise<Record<string, string>> => {
  const token = await tokenService.getToken();
  if (!token) return {};
  return { Authorization: `Bearer ${token}` };
};

export const fetchNotifications = async (limit = 50, offset = 0): Promise<Notification[]> => {
  try {
    const headers = await getAuthHeaders();
    const res = await fetch(
      `${API_URL}/api/v2/notification-history?limit=${limit}&offset=${offset}`,
      {
        credentials: "include",
        headers,
      }
    );
    if (!res.ok) return [];
    const data = await res.json();
    return data?.data?.notifications ?? [];
  } catch {
    return [];
  }
};

export const fetchUnreadCount = async (): Promise<number> => {
  try {
    const headers = await getAuthHeaders();
    const res = await fetch(`${API_URL}/api/v2/notification-history/unread-count`, {
      credentials: "include",
      headers,
    });
    if (!res.ok) return 0;
    const data = await res.json();
    return data?.data?.count ?? 0;
  } catch {
    return 0;
  }
};

export const markNotificationRead = async (id: number): Promise<boolean> => {
  try {
    const headers = await getAuthHeaders();
    const res = await fetch(`${API_URL}/api/v2/notification-history/${id}/read`, {
      method: "PUT",
      credentials: "include",
      headers,
    });
    return res.ok;
  } catch {
    return false;
  }
};

export const markAllNotificationsRead = async (): Promise<boolean> => {
  try {
    const headers = await getAuthHeaders();
    const res = await fetch(`${API_URL}/api/v2/notification-history/read-all`, {
      method: "PUT",
      credentials: "include",
      headers,
    });
    return res.ok;
  } catch {
    return false;
  }
};
